import styled from "styled-components";
import { COLORS, responsive, tabletAboveRange, tabletMidRange } from "../../../../styles/constants.style";

export const CreateProgramTabsWrapper = styled.div`
  margin-top: 32px;
  ${responsive.MOBILE`
    margin-top: 16px;
      .sales-office-grid {
          width: 100%;
        }
  `}
  .MuiGrid2-root {
    ${responsive.MOBILE`
      padding-right: 0;
    `}
  }

  .MuiTabs-flexContainer {
    border-bottom: 5px solid ${COLORS.cirrus_black3};
    ${responsive.MOBILE`
      width: max-content;
    `}
  }

  .project-detail {
    padding: 0 0 24px 16px;
    ${responsive.MOBILE`
      padding: 0 8px 16px 8px;  
    `}
  }

  .active-change-status-project {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    ${responsive.MOBILE`
       align-items: center;
       width: 100%;
       margin: 8px 8px 16px 0;
    `}
  }

  .accordion-header {
    margin: 26px 0px;

    ${responsive.MOBILE`
      margin: 16px 0;
      `}
  }
  .project-fee-header {
    ${responsive.MOBILE`
        margin: 0 0;
      `}
  }
  .office-contact-header {
    ${responsive.MOBILE`
      margin-top: 0;
    `}
  }
  .project-fee-tab {
    ${responsive.MOBILE`
      margin-top: 0;
    `}
  }
  .status-label {
    margin: 24px 16px 24px 16px;
    ${responsive.MOBILE`
      margin: 16px 8px 0 8px;
    `}
  }

  .activity-timeline {
    padding-top: 16px;
    .MuiGrid2-container {
      padding: 0px;
      margin-top: 0;
    }

    .filter-wrapper {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: flex-start;
      padding-bottom: 16px;
      padding-left: 16px;
      border-bottom: 1px solid ${COLORS.cirrus_black4};
      gap: 16px;

      ${responsive.TABLET_LANDSCAPE`
        align-items: flex-end;
      `}

      .add-activity-wrapper {
        margin-left: auto; /* Align this to the right */
        margin-right: 24px;
      }
      ${responsive.TABLET_PORTRAIT`
          align-items: flex-end; 
        `}
      ${responsive.MOBILE`
          padding-bottom: 16px;
          padding-left: 8px;
          .modality {
            margin-top: 0;
          }
        .add-activity-wrapper {
              width: 100%;
              margin-top: 16px;
              padding-right: 8px;
              margin-right: 0;
            button.MuiButton-root {
                width: 100%;
                display: block;
            }
          }
      `}
    }

    .duration-picker-wrapper {
      background: ${COLORS.cirrus_black2};
      padding: 16px;
      .MuiPickersTextField-root,
      .MuiPickersInputBase-root {
        width: 100%;
        ${responsive.MOBILE`
          padding: 8px;
        `}
      }
      .go-btn-grid {
        display: flex;

        .MuiButtonBase-root {
          margin-top: auto;
        }
      }
    }
  }

  .status-header {
    display: flex;
    justify-content: space-between;
    .MuiButton-textPrimary {
      height: 40px;
      margin-right: 16px;
    }
  }
  .currency-container {
    width: 50%;
  }
  .currency-range-container {
    width: 50%;
    margin-top: 30px;
  }
  .currency-container-main {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 10px;
  }
  .currency-container-textfield {
    width: calc(100% - 132px);
  }
  .select-preference-container {
    border-top: 1px dashed ${COLORS.primary_light_blue};
  }
  .select-preference-authorized {
    display: flex;
    align-items: center;
  }

  .career-goal-label-style {
    margin: 34px 16px 24px 16px;
    font-size: 20px;
    color: ${COLORS.cirrus_black10};
  }
  .checkbox-container-career-goal {
    margin: 24px 16px 24px 16px;
    color: ${COLORS.primary_light_blue1};
  }
`;

export const AddActivityWrapper = styled.div`
  padding: 24px 0px 24px 16px;
  ${responsive.MOBILE`
      padding: 0 0 16px 16px; 
  `}
  .MuiGrid2-root {
    padding-right: 18px;
    margin-top: 40px;

    &:nth-child(-n + 3) {
      margin-top: 0px;
    }
    ${tabletAboveRange`
      &:nth-child(3) {
        margin-top: 40px;
      }
    `}
    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 0px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}
    ${tabletMidRange`
      &:nth-child(3) {
        margin-top: 40px;
      }
    `}
    ${responsive.MOBILE`
      padding-right: 16px;
      &:nth-child(1) {
        margin-top: 0px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
        }
    `}
  }

  .MuiGrid2-container {
    padding-right: 0px;
  }
`;
